<!-- 
RiskAttributesModal.vue
功能：投資風險屬性說明視窗
作者：i94005pi01 周厚鈞
完成：2022-12-19
-->
<template>
  <div id="risk-attributes-modal" class="modal fade" :class="{'is-open': open}">
    <div class="modal-dialog" style="width: 960px;">
      <div class="modal-content">
        <div class="modal-header">
          <div>
            <span class="cathay-cust-info-title text-green">投資型保險商品保戶風險適性問卷</span>
            <div class="padding-top-use font-weight-bold font-20" style="max-width: 920px">
              <span style="word-wrap: break-word">為推薦客戶合適的投資型商品，產出投資型商品建議書前須先充分了解客戶投資風險屬性，請確實讓客戶親自進行投資風險屬性評估，且切勿冒用客戶身分填寫或做答題引導。<br>
                1.點選「複製連結」將問卷連結發送予客戶做投資風險屬性評估<br>
                2.如需供客戶填寫紙本風險適性問卷，請至管理大師>線上列印作業>保全申請書列印>投資型保險商品保戶風險適性問卷下載
               </span> 
            </div>
            <div class="mt-3" style="text-align: right">
              <button class="btn btn-primary" @click="doCopy()"
              v-html="'<span style=\'font-size:1.25rem\'>複製連結<span>'"
            ></button>
            </div>
          </div>
        </div>
        <div class="modal-header">
          <div>
            <span class="cathay-cust-info-title text-green">投資型商品投資風險屬性聲明書</span>
            <div class="padding-top-use font-weight-bold font-20" style="max-width: 920px">
              <span style="word-wrap: break-word">若客戶風險屬性顯示「XX型/ 客戶尚未確認」，表示仍須請客戶簽署此聲明書確認評估結果。建議您可透過行動投保送件，以數位簽名方式簽署聲明書。(「投資型商品投資風險屬性聲明書」為新契約投保時應附文件)<br>※須列印紙本「投資型商品投資風險屬性聲明書」的情況：<br>1.新契約以紙本送件時<br>2.客戶尚未確認過其評估結果，辦理紙本保全變更時
               </span> 
            </div>
            <div class="mt-3" style="text-align: right">
              <button 
                class="btn btn-primary" 
                @click="doPrintDeclaration()"
                :disabled="!getEnableKYCPrint"
                v-html="'<span style=\'font-size:1.25rem\'>聲明書列印<span>'">
              </button>
            </div>
          </div>
        </div>
        <div class="modal-header">
          <a @click="$emit('close')" class="close">
            <i class="icon-close"></i>
          </a>
          <div>
            <span class="cathay-cust-info-title text-green">投資風險屬性</span>
            <div class="padding-top-use text-green font-weight-bold font-20">
              <span>客戶近一年最新可參考之投資風險屬性，方便您更了解目前客戶的屬性狀況，以推薦適合的投資型商品。</span>
            </div>
          </div>
        </div>
        <div class="modal-body">
          <div class="insurance-row row">
            <table id="cathay-cust-info-text" class="table datatable table-striped">
              <thead>
                <tr>
                  <th width="18%" class="text-center">客戶投資風險屬性</th>
                  <th width="37%" class="text-center">可選擇之投資標的風險類型</th>
                  <th width="45%" class="text-center">說明</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>保守型<br>(不適合購買投資型商品)</td>
                  <td>
                    <ul>
                      <li>無</li>
                    </ul>
                  </td>
                  <td>您屬於風險趨避者，通常期望避免投資本金之損失，但仍願意承受少量風險以增加投資報酬；投資主要為風險等級較低之商品；您瞭解並接受前述投資方式的本金損失風險略高於存款。<br><span class="text-red">(建議選擇投資型保險之外的商品)</span></td>
                </tr>
                <tr>
                  <td>保守型</td>
                  <td>
                    <ul>
                      <li>低風險(RR1)及中低風險(RR2)之投資標的</li>
                      <li>保守型投資標的</li>
                    </ul>
                  </td>
                  <td>您屬於風險趨避者，通常期望避免投資本金之損失，但仍願意承受少量風險以增加投資報酬；投資主要為風險等級較低之商品；您瞭解並接受前述投資方式的本金損失風險略高於存款。</td>
                </tr>
                <tr>
                  <td>穩健型</td>
                  <td>
                    <ul>
                      <li>低度風險(RR1)、中低度風險(RR2)、中度風險(RR3)</li>
                      <li>保守型及穩健型投資標的</li>
                    </ul>
                  </td>
                  <td>您屬於風險中立者，願意承擔部分風險以增加投資報酬；為了獲得提高投資報酬之機會，可以接受投資包含不同風險等級之商品；您瞭解並接受前述投資方式可能產生部分虧損及投資之價值可能頻繁波動。可選擇穩健型投資型商品。</td>
                </tr>
                <tr>
                  <td>積極型</td>
                  <td>
                    <ul>
                      <li>可依個人需求選擇低風險(RR1)至高風險(RR5)的任何投資標的</li>
                      <li>可依個人需求選擇保守型至積極型之任何投資標的</li>
                    </ul>
                  </td>
                  <td>您屬於風險追求者，願意承擔相當程度風險以增加投資報酬；可以接受將所有資金投資於風險較高之商品，例如股票型基金，藉以獲取較高投資報酬；您瞭解並接受前述投資方式可能造成全部虧損及投資之價值可能頻繁且劇烈波動。可選擇積極、穩健型投資型商品。</td>
                </tr>
                <tr>
                  <td>無有效風險屬性</td>
                  <td>--</td>
                  <td>該客戶無填寫過風險適性問卷或距前次評估日期已逾一年，不得匯入行動投保，<b>請提供上方風險適性問卷連結給客戶填寫</b>。</td>
                </tr>
                <tr>
                  <td>無有效風險屬性(請確認客戶生日資訊)</td>
                  <td>--</td>
                  <td>該客戶CRM生日與KYC問卷的生日不一致，若確定CRM的生日正確無誤，<b>請附上客戶的身分證明文件，寫簡覆表至審查企劃科修改</b>。</td>
                </tr>
                <tr>
                  <td>--</td>
                  <td>--</td>
                  <td>該客戶資料不齊全(無身份證字號/生日)或目前系統顯示異常。</td>
                </tr>
              </tbody>
            </table>

            <div class="div-margin-left">
              <span>註1：投資風險屬性文字後括弧內之日期(含)為此投資風險屬性之有效期限。</span>
            </div>
            <div class="div-margin-left">
              <span>註2：產出投資型商品建議書前須先充分了解客戶投資風險屬性，請於訪談客戶資料後，由客戶親自進行投資風險屬性評估，以推</span><br><span class="ml-40">薦其適合之投資型商品。</span>
            </div>
            <div class="div-margin-left">
              <span>註3：若客戶風險屬性顯示「XX型/ 客戶尚未確認」，表示仍須請客戶簽署「投資型商品投資風險屬性聲明書」確認評估結果。建</span><br><span class="ml-40">議您可透過行動投保送件，以數位簽名方式簽署聲明書。(「投資型商品投資風險屬性聲明書」為新契約投保時應附文件)</span>
            </div>
            <div class="div-margin-left mb-3">
              <span>註4：須列印紙本「投資型商品投資風險屬性聲明書」的情況：</span><br><span class="ml-40">1. 新契約以紙本送件時。</span><br><span class="ml-40"></span><span>2. 客戶尚未確認過其評估結果，辦理紙本保全變更時。</span>
            </div>

            <table class="table datatable table-striped mt-3 mb-3">
              <caption class="text-green font-weight-bold font-18 mb-1">客戶有下列任一情況，建議書會有提醒及浮水印：無身分證字號、無有效風險屬性、風險屬性與商品屬性不符。</caption>
              <thead>
                <tr>
                  <th  width="52%" class="text-center">建議書的提醒文字及報表浮水印</th>
                  <th  width="48%" class="text-center">處理方式</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>要保人近一年最新可參考之<b>投資風險屬性與本商品風險類型不符</b>，不得匯入行動投保</td>
                  <td rowspan="2">客戶的風險屬性不適合購買此商品，請修改為適合客戶風險屬性之商品。</td>
                </tr>
                <tr>
                  <td>要保人近一年最新可參考之<b>投資風險屬性與本商品風險類型不符</b>，僅能產出教育用投資型商品建議書，不得作為新契約銷售文件</td>
                </tr>
                <tr>
                  <td>要保人<b>近一年無有效風險屬性</b>，不得匯入行動投保</td>
                  <td rowspan="2">該客戶無填寫過風險適性問卷或距前次評估日期已逾一年，不得匯入行動投保，<b>請提供上方風險適性問卷連結給客戶填寫</b>，填完送出後，重新整理建議書畫面即可繼續操作。</td>
                </tr>
                <tr>
                  <td>要保人<b>近一年無有效風險屬性</b>，僅能產出教育用投資型商品建議書，不得作為新契約銷售文件</td>
                </tr>
                <tr>
                  <td>要保人生日等資訊需確認，不得匯入行動投保</td>
                  <td rowspan="2">該客戶CRM與KYC問卷的生日不一致，若確定CRM的生日正確無誤，<b>請附上客戶的身分證明文件，寫簡覆表至審查企劃科修改</b>。</td>
                </tr>
                <tr>
                  <td>要保人生日等資訊需確認，僅能產出教育用投資型商品建議書，不得作為新契約銷售文件</td>
                </tr>
              </tbody>
            </table>

            <table id="cathay-cust-info-text" class="table datatable table-striped mb-3">
              <thead>
                <tr>
                  <th width="40%" class="text-center">查詢項目</th>
                  <th width="20%" class="text-center">單位</th>
                  <th width="40%" class="text-center">聯絡方式</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(value, index) in riskAttributesList" :key="`table-td-${index}`">
                  <td>{{value.description}}</td>
                  <td class="text-center">{{value.dev_name}}</td>
                  <td>{{value.contact}}<br>{{value.contact_tel}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { commonMixin } from "@/mixins/common";
import { getContactInfo, getKYCPrint ,getRisk_Attributes, getRiskAttributesList } from "@/service";
export default {
  name: "RiskAttributesModal",
  mixins: [commonMixin],
  props: {
    open: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      default: () => {
        return [];
      }
    },
    kyc_lvl_name: {
      type: String,
      default: ''
    },
    enableKYCPrint: {
      type: Boolean,
      required: true
    },
    custId: {
      type: String,
      default: ''
    },
    custBirth: {
      type: String,
      default: ''
    }
  },
  watch: {
    open: function(val) {
      if (val) {
        //this.registerHanlink(); // for hard word
      }
    }
  },
  computed:{
    getEnableKYCPrint(){
      return this.enableKYCPrint;
    },
    getKycLvlName(){
      return this.kyc_lvl_name
    },
    getCustBirth(){
      return this.custBirth
    }
  },
  data() {
    return {
      apply_date:'',
      riskAttributesList: []
    };
  },
  mounted() {
    getContactInfo(this.$store.state.userInfo.id, "投資風險屬性").then(
      (result) => {
        if (result.header && result.header.status === "200") {
          this.riskAttributesList = result.body.data;
        }
      }
    );
  },
  methods:{
    doCopy(){
      // 依環境指定url
      let href = window.location.href;
      let linkUrl ='';
      let url_Shortener = "https://cathaylife.tw/Yl9Gxjz";
      if (href.indexOf("tmycrm") !== -1) {
        url_Shortener = "https://cathaylife.tw/Yl9Gxjz";
      } else if (href.indexOf("smycrm") !== -1) {
        url_Shortener = "https://cathaylife.tw/3KOkdvP";
      } else if (href.indexOf("mycrm") !== -1) {
        url_Shortener = "https://cathaylife.tw/J3R1746";
      }
      linkUrl = url_Shortener

      const tempInput = document.createElement('input');
      tempInput.value="親愛的客戶您好，我是國泰人壽業務員" + this.$store.state.userInfo.name + "，為推薦您適合的投資型保險商品，需先請您進行投資風險屬性評估；請利用以下連結前往填寫風險適性問卷，感謝您的配合，祝您事事順心。問卷連結 " + linkUrl;
      document.body.appendChild(tempInput);
      tempInput.select();
      tempInput.setSelectionRange(0,99999);
      document.execCommand('cut');
      document.body.removeChild(tempInput);

      this.$toast.info({ title: "已複製風險適性問卷填寫連結" });
    },
    async doPrintDeclaration(){        
        let newWindow;
        if (!this.isBox) {
          newWindow = window.open("/crm/assets/common/ajax-loader.gif")
        }
        // 取得投資風險屬性資料中的受理日期
        await getRisk_Attributes(this.custId, "", this.getCustBirth).then(result =>{
          if(result.header && result.header.status === "200"){
            this.apply_date = result.body.apply_date; 
          } else {
            if(result.header && result.header.message) {
              this.$toast.info({title: result.header.message})
            } else {
              this.$toast.info({title: '查詢投資風險屬性失敗,請重新操作'})
            }
          }
        });        
        //開啟KYC pdf
        getKYCPrint(this.$store.state.userInfo.id,this.apply_date,this.getKycLvlName,this.custId,"1").then(result => {
          this.isloading = false; //關閉遮罩
          let arrayBuffer = new Uint8Array(result.file).buffer;
          if (this.isBox) {
            this.boxSendBase64PdfData(arrayBuffer);
          } else {            
            let file = new Blob([arrayBuffer], { type: "application/pdf" });
            let file_name = result.pdfFileName;
            if (window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(file, file_name);
            } else {
              newWindow.location = URL.createObjectURL(file);
            }            
          }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.cathay-cust-info-title {
  font-size: 30px;
  font-weight: 600;
  margin-bottom: 0.5rem;
  margin-right: 0.5rem;
  font-family: inherit;
  line-height: 1.2;
}

.padding-top-use {
  padding-top: 1.5rem;
}

.text-center {
  text-align: center;
}

.table.datatable {
  width: 90%;
  margin-left: 1.2rem;
  tbody {
    tr > td {
      &:first-child {
        padding-top: 10px;
      }
    }
  }
}

.div-margin-left {
  margin-left: 1.2rem;
}

.font-20 {
  font-size: 20px;
}

.font-18 {
  font-size: 18px;
}

.ml-40{
  margin-left: 40px;
}
</style>